import React, { FunctionComponent, memo } from 'react';
import * as CSS from './RoundButton.scss';

const RoundButton: FunctionComponent<React.JSX.IntrinsicElements['button']> = (props) => {
	const { className = '', ...rest } = props;
	return (
		<button className={`${CSS.RoundButton} ${className}`} {...rest}>
			{props.children}
		</button>
	);
};

RoundButton.displayName = 'RoundButton';
export default memo(RoundButton);
